import React from 'react';
import Card from '~/src/components/Card';
import LoadingOverlay from '~/src/components/PageLayout/LoadingOverlay';
import { Heading } from '~/src/components/Typography';

interface SettingsComplianceProps {
  isLoading: boolean;
  errorMessage: string | null;
  legalAgreementUrl: string | null;
  legacyTosUrl: string | null;
}

const SettingsCompliance = ({
  isLoading,
  errorMessage,
  legalAgreementUrl,
  legacyTosUrl,
}: SettingsComplianceProps) => {
  return (
    <Card dynamic>
      <Heading>Compliance</Heading>
      {isLoading ? (
        <LoadingOverlay />
      ) : errorMessage ? (
        <div>{errorMessage}</div>
      ) : legalAgreementUrl ? (
        <iframe
          src={legalAgreementUrl}
          title="Legal Agreement"
          style={{
            width: '100%',
            height: '420px',
            border: 'none',
          }}
        />
      ) : legacyTosUrl ? (
        <>
          <br />
          <div className="bg-white border border-gray-200 rounded">
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm text-left">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-200">
                    <th className="px-4 py-3 font-medium text-gray-700">
                      Terms
                    </th>
                    <th className="px-4 py-3 font-medium text-gray-700">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="px-4 py-3">
                      <a
                        href={legacyTosUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900"
                        tabIndex={0}
                        aria-label="View Terms of Service"
                      >
                        Terms of Service
                      </a>
                    </td>
                    <td className="px-4 py-3">
                      <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700">
                        Accepted
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : null}
    </Card>
  );
};

export default SettingsCompliance;
